import { useState, useEffect } from "react";
import axios from "axios";
import { changeLanguage } from "i18next";
import type { AxiosResponse } from "axios";
import { API_URL } from "consts";
import { getURL, setStateURL, getTypedVal } from "utils/urls";
import { createRequestJSON } from "utils";
import type { IRoadLayoutConfig, ILuminaireLayoutConfig, ILightingClassConfig, IOptimizationConfig, IRoadwayConfig, IFamilyConfig } from "types";
import type { ApiResponse } from "../types";

interface UseResultFetchParams {
  portfolioId: string | number;
  familyConfig: IFamilyConfig;
  roadLayoutConfig: IRoadLayoutConfig;
  roadwayConfig: IRoadwayConfig;
  lightingClassConfig: ILightingClassConfig;
  luminaireLayoutConfig: ILuminaireLayoutConfig;
  optimizationConfig: IOptimizationConfig;
  appLang: string;
}

export function useResultFetch({
  portfolioId,
  familyConfig,
  roadLayoutConfig,
  roadwayConfig,
  lightingClassConfig,
  luminaireLayoutConfig,
  optimizationConfig,
  appLang,
}: UseResultFetchParams): {
  data: AxiosResponse<ApiResponse> | null;
  error: { message: string | null };
} {
  const [data, setData] = useState<AxiosResponse<ApiResponse> | null>(null);
  const [error, setError] = useState<{ message: string | null }>({ message: null });

  useEffect(() => {
    const dataToSubmit = createRequestJSON(
      portfolioId,
      familyConfig,
      roadLayoutConfig,
      roadwayConfig,
      lightingClassConfig,
      luminaireLayoutConfig,
      optimizationConfig
    );

    const urlParams = getURL();
    const searchParams = new URLSearchParams(urlParams);
    (dataToSubmit.request.params.filter.color as string[] | undefined) = searchParams.get("color") ? searchParams.get("color")?.split(",") : undefined;
    (dataToSubmit.request.params.filter.flux as string[] | undefined) = searchParams.get("flux") ? searchParams.get("flux")?.split(",") : undefined;
    (dataToSubmit.request.params.filter.optic as string[] | undefined) = searchParams.get("optic") ? searchParams.get("optic")?.split(",") : undefined;

    const lang_code = getTypedVal("lang_code", "en") || "en";
    const lang = appLang || "en";
    changeLanguage(lang_code);
    setStateURL("lang_code", lang);

    const url = `${API_URL}/api/find-street/`;

    axios
      .post(url, dataToSubmit)
      .then((returnedData) => setData(returnedData))
      .catch((err) => setError(err.toJSON()));
  }, [familyConfig, lightingClassConfig, luminaireLayoutConfig, optimizationConfig, roadLayoutConfig, roadwayConfig]);

  return { data, error };
}
